export function formatDateWithWeekday(dateString) {
        const date = new Date(dateString);
        const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });       // Sat
        const monthDay = date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' }); // May 03
        const year = date.getFullYear(); // 2025
        return `${monthDay} ${year} (${weekday})`;
};
export const formatTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      };
      
export const calculateDuration = (start, end) => {
        const diff = Math.abs(new Date(end) - new Date(start));
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return `${hours}h ${minutes}m`;
      };
      
export const calculateLayover = (arrival, departure) => {
        const diff = Math.abs(new Date(departure) - new Date(arrival));
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return `${hours}h ${minutes}m`;
      };